import * as React from 'react';
import { makeStyles } from '@material-ui/styles';

import Mapbox from '../../../../../components/Mapbox';
import { API_HOST } from '../../../../../constants/app';
import type { AuthorizedParcel } from '../../../../../types';

const useStyles = makeStyles(({ typography, breakpoints }) => ({
  map: {
    [breakpoints.down('xs')]: {
      marginLeft: typography.pxToRem(5),
      marginRight: typography.pxToRem(5),
    },
    borderRadius: typography.pxToRem(10),
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  mapContainer: {
    width: '100%',
    height: '100%',
    borderRadius: typography.pxToRem(10),
    overflow: 'hidden',
  },
}));

type Props = {
  children: React.node,
  parcel: AuthorizedParcel,
  toggleMap: boolean,
  showMap?: boolean,
  size?: string,
};

const MapContainer = ({
  children,
  parcel,
  toggleMap,
  showMap = false,
  size = '1200*600',
}: Props) => {
  const styles = useStyles();
  const mapSrc = `${API_HOST}/map/depot?depotCode=${parcel.deliveryDepot.depotCode}&size=${size}`;

  return showMap ? (
    <Mapbox
      mapSrc={mapSrc}
      onClose={toggleMap}
      boxShadow={false}
      className={styles.mapContainer}
      imageFill
    />
  ) : (
    children
  );
};

export default MapContainer;
